import {
  arbitrum,
  arbitrumNova,
  avalanche,
  avalancheFuji,
  base,
  mainnet,
  optimism,
  polygon,
  sepolia,
  zora,
  zoraTestnet,
  ronin,
} from "@wagmi/chains"
import type { Chain } from "viem"
import {
  blast,
  blastSepolia,
  polygonAmoy,
  klaytn,
  klaytnBaobab,
  b3Sepolia,
  seiTestnet,
  b3,
  flowTestnet,
  apeChain,
  curtis,
  sei,
  flowMainnet,
  soneiumMinato,
  soneium,
  shape,
  unichain,
  saigon,
  abstractTestnet,
} from "viem/chains"

export const SUPPORTED_CHAINS = [
  arbitrum,
  arbitrumNova,
  avalanche,
  avalancheFuji,
  // Override blast chain rpc url
  {
    ...blast,
    rpcUrls: {
      default: {
        http: ["https://rpc.ankr.com/blast"],
      },
    },
  },
  sei,
  blastSepolia,
  base,
  mainnet,
  sepolia,
  {
    id: 49_321,
    name: "GUNZ Testnet",
    nativeCurrency: { name: "GUN", symbol: "GUN", decimals: 18 },
    rpcUrls: {
      default: {
        http: [
          "https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc",
        ],
      },
    },
    blockExplorers: {
      default: {
        name: "Gunzscan",
        url: "https://testnet.gunzscan.io/",
      },
    },
    testnet: true,
  } as Chain,
  {
    id: 43_419,
    name: "Gunzilla",
    nativeCurrency: { name: "GUN", symbol: "GUN", decimals: 18 },
    rpcUrls: {
      default: {
        http: [
          "https://rpc.gunzchain.io/ext/bc/2M47TxWHGnhNtq6pM5zPXdATBtuqubxn5EPFgFmEawCQr9WFML/rpc",
        ],
      },
    },
    blockExplorers: {
      default: {
        name: "Gunzscan",
        url: "https://gunzscan.io/",
      },
    },
  } as Chain,
  {
    id: 10143,
    name: "Monad Testnet",
    nativeCurrency: { name: "MON", symbol: "MON", decimals: 18 },
    rpcUrls: {
      default: {
        http: [
          "https://monad-testnet.g.alchemy.com/v2/d3HKIjBXx3HMTnPWU9Ftv7cW8LL2BtWr",
        ],
      },
    },
    blockExplorers: {
      default: {
        name: "Monadexplorer",
        url: "https://testnet.monadexplorer.com",
      },
    },
    testnet: true,
  } as Chain,
  {
    id: 80094,
    name: "Berachain",
    nativeCurrency: { name: "BERA", symbol: "BERA", decimals: 18 },
    rpcUrls: {
      default: {
        http: ["https://rpc.berachain.com/"],
      },
    },
    blockExplorers: {
      default: {
        name: "Berascan",
        url: "https://berascan.com/",
      },
    },
  } as Chain,
  seiTestnet,
  klaytn,
  klaytnBaobab,
  optimism,
  polygon,
  polygonAmoy,
  zora,
  zoraTestnet,
  b3Sepolia,
  b3,
  flowTestnet,
  flowMainnet,
  curtis,
  apeChain,
  soneiumMinato,
  soneium,
  ronin,
  shape,
  unichain,
  saigon,
  abstractTestnet,
]
